import { BookingFlow } from '../store/bookingAvailabilitySlice'

export const BOOKING_FLOW_QUERY_PARAM = 'bookingFlow'
export function getBookingFlowFromSearchParams(
  searchParams: URLSearchParams
): BookingFlow | null {
  const bookingFlow = searchParams.get(BOOKING_FLOW_QUERY_PARAM)

  return parseBookingFlow(bookingFlow)
}

function parseBookingFlow(data: unknown): BookingFlow | null {
  if (data === '0') {
    return BookingFlow.SPOTS
  }

  if (data === '1') {
    return BookingFlow.TICKETS
  }

  return null
}
